import React from 'react';
import { arrayOf, func, object, oneOf } from 'prop-types';
import classNames from 'classnames';
import { Radio } from '@fiverr-private/fit';
import { connect } from 'react-redux';
import { I18n } from '@fiverr-private/fiverr_context';
import { CHECKOUT_PLANS } from '../../../../../../../utils/packagesUtils/constants';
import { PACKAGE_POSITIONS } from '../../../../../../../types/packagePositions';
import { MP_CHANGED_CHECKOUT_PLAN } from '../../../../../../../utils/mixPanelEvents';
import { CHECKOUT_PLAN_RADIO } from '../constants';
import { selectCheckoutPlan } from '../../../../../../../actions/packages';
import { getRecurringOptions, getSelectedCheckoutPlan } from '../../../../../../../reducers/packages';
import RecurringOptionSelect from '../../../../../../shared/RecurringOptionSelect';
import SingleRecurringOption from './SingleRecurringOption';

import './style.scss';

const source = PACKAGE_POSITIONS.TABS;

const RecurringOrderPlanRadio = (
    { recurringOptions, selectedCheckoutPlan, selectCheckoutPlan },
    { biEvents }
) => {

    const onChange = () => {
        const selectedCheckoutPlan = CHECKOUT_PLANS.RECURRING_ORDER;

        selectCheckoutPlan({ selectedCheckoutPlan });

        reportChangeCheckoutPlan(selectedCheckoutPlan);
    };

    const reportChangeCheckoutPlan = (selectedCheckoutPlan) => {
        const params = { source, selectedCheckoutPlan };

        biEvents.sendMixPanelEvent({
            eventName: MP_CHANGED_CHECKOUT_PLAN,
            params
        });
    };

    const checked = selectedCheckoutPlan === CHECKOUT_PLANS.RECURRING_ORDER;
    const isSingleOption = recurringOptions.length === 1;

    const wrapperClass = classNames(
        'recurring-order-plan-radio',
        {
            checked,
            'single-option': isSingleOption
        }
    );

    return (
        <div className={wrapperClass}>
            <Radio name={CHECKOUT_PLAN_RADIO}
                checked={checked}
                onChange={onChange}
                color={Radio.COLORS.GREEN}>
                <I18n k="gig_page_perseus.recurring.subscribe_for"/>
                {!isSingleOption && <span className="dots">...</span>}
            </Radio>
            {
                isSingleOption ?
                    <SingleRecurringOption/> :
                    <RecurringOptionSelect className="option-select"
                        source={PACKAGE_POSITIONS.TABS}/>
            }

        </div>
    );
};

RecurringOrderPlanRadio.propTypes = {
    recurringOptions: arrayOf(object),
    selectedCheckoutPlan: oneOf(Object.values(CHECKOUT_PLANS)),
    selectCheckoutPlan: func
};

RecurringOrderPlanRadio.contextTypes = {
    biEvents: object
};

const mapStateToProps = ({ packages }) => {
    const recurringOptions = getRecurringOptions(packages);
    const selectedCheckoutPlan = getSelectedCheckoutPlan(packages);

    return { recurringOptions, selectedCheckoutPlan };
};

const mapDispatchToProps = { selectCheckoutPlan };

export { RecurringOrderPlanRadio };
export default connect(mapStateToProps, mapDispatchToProps)(RecurringOrderPlanRadio);
